import React from 'react';

function CustomerBilling() {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Billing</h1>
        <p className="subtitle">View payment history and invoices</p>
      </div>
      <div className="empty-state">
        <p>Billing information coming soon!</p>
      </div>
    </div>
  );
}

export default CustomerBilling;
